import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { StatementsFacade } from '@app/modules/statements/services/statements.facade';
import { tap } from 'rxjs/operators';

/**
 * Consumes the state in the statementsService, so the parent component must
 * tell the service to load the data
 */
@Component({
  standalone: false,
  selector: 'sbnb-statement-tabs',
  templateUrl: './statement-tabs.component.html',
  styleUrls: ['./statement-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatementTabsComponent implements OnInit {
  public selectedTabIndex = 0;
  public openStatementsState$ = this.statementsService.openStatementsState$;
  public inReviewStatementsState$ = this.statementsService.inReviewStatementsState$.pipe(
    tap((state) => {
      if (state.data?.length) {
        this.selectedTabIndex = 1;
      }
    })
  );
  public closedStatementsState$ = this.statementsService.closedStatementsState$;
  public displayedColumns = ['month', 'type', 'property', 'owner'];
  public statementsDashboardUrl = '/operations/statements/';

  constructor(private statementsService: StatementsFacade) {}

  ngOnInit(): void {}
}
